.spinner {
  display: inline-flex;
  gap: 3px;
  align-items: center;
}

.spinner span {
  width: 5px;
  height: 5px;
  background: currentColor;
  opacity: 0.3;
  animation: blink 0.9s steps(1, end) infinite;
}
.spinner span:nth-child(2) {
  animation-delay: 0.3s;
}
.spinner span:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes blink {
  0%,
  33% {
    opacity: 1;
  }
  34%,
  100% {
    opacity: 0.3;
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner span {
    animation: none;
    opacity: 0.8;
  }
}
